import React, { useEffect, useState } from "react";
import { createOrUpdateShape } from "orion-components/GlobalData/Actions";
import { useDispatch, useSelector } from "react-redux";
import { getDir } from "orion-components/i18n/Config/selector";
import { Translate } from "orion-components/i18n";
import { styled } from "@mui/material/styles";
import { TextField, MenuItem } from "@mui/material";
import PropTypes from "prop-types";

const CustomizedTextField = styled(TextField)({
	"& label": {
		color: "#9A9FA3",
		fontSize: 12
	},
	"& label.Mui-focused": {
		color: "#9A9FA3"
	},
	"& .MuiOutlinedInput-root": {
		fontSize: 12,
		color: "#FFFFFF",
		fontFamily: "Roboto",
		"& fieldset": {
			borderColor: "#5E6571"
		},
		"&:hover fieldset": {
			borderColor: "#4DB5F4"
		},
		"&.Mui-focused fieldset": {
			borderColor: "#4DB5F4"
		}
	}
});

const MapDisplayOptions = ({ shapeType }) => {
	const dir = useSelector((state) => getDir(state));
	const dispatch = useDispatch();
	const { mapTools } = useSelector((state) => state.mapState);
	const app = useSelector((state) => state.appId);
	const isEventApp = app === "events-app" ? true : false;
	const [displayOnEventActive, setDisplayOnEventActive] = useState(true);

	useEffect(() => {
		const { feature } = mapTools;
		if (isEventApp) {
			if (feature) {
				const { properties } = feature;
				const { displayOnEventActive } = properties;
				dispatch(createOrUpdateShape(shapeType, { displayOnEventActive }));
				setDisplayOnEventActive(displayOnEventActive);
			} else {
				dispatch(createOrUpdateShape(shapeType, { displayOnEventActive }));
			}
		}
	}, []);
	return (
		<>
			{isEventApp ? (
				<div style={{ width: "100%", marginBottom: 36, marginTop: 45, marginLeft: 20 }}>
					<p
						style={{
							fontSize: 11,
							fontFamily: "Roboto",
							letterSpacing: 0,
							color: "#9A9FA3",
							opacity: "1",
							textAlign: dir === "ltr" ? "left" : "right",
							marginBottom: 5.5
						}}
					>
						<Translate value="global.sharedComponents.shapeEditor.components.shared.mapDisplayOptions.title" />
					</p>
					<CustomizedTextField
						variant="outlined"
						name="symbol"
						value={displayOnEventActive}
						onChange={(e) => {
							setDisplayOnEventActive(e.target.value);
							dispatch(createOrUpdateShape(shapeType, { displayOnEventActive: e.target.value }));
						}}
						sx={{ width: 380 }}
						inputProps={{
							style: { width: 240, height: 34 }
						}}
						select
					>
						<MenuItem value={true}>
							<Translate value="global.sharedComponents.shapeEditor.components.shared.mapDisplayOptions.showWhenActive" />
						</MenuItem>
						<MenuItem value={false}>
							<Translate value="global.sharedComponents.shapeEditor.components.shared.mapDisplayOptions.alwaysShow" />
						</MenuItem>
					</CustomizedTextField>
				</div>
			) : null}
		</>
	);
};

MapDisplayOptions.propTypes = {
	shapeType: PropTypes.string.isRequired
};

export default MapDisplayOptions;
